<template>
  <div id="signin">
    <h2>サインイン</h2>
    <button @click="signIn">匿名ユーザでサインイン</button> <br>
    <button @click="signInWithGoogle">Googleアカウントでサインイン</button>

  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name:"Signin",
  data(){
    return {
      email: "",
      password: ""
    }
  },
  methods: {
    signIn: function(){
      firebase.auth().signInAnonymously ()
    .then(()=>{
      alert("ログインに成功しました");
      this.$router.push("/");
    })
    .catch(error =>{
      alert(error.message);
    });
    },
    
    signInWithGoogle: function(){
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth()
      .signInWithPopup(provider)
      .then(() => {
        this.$router.push("/");
      })
      .catch(error =>{
        alert(error.message)
      })
    }
  }
}
</script>



<style>
</style>